var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('RegisterLessons',{staticClass:"rounded-t-0",attrs:{"tile":"","flat":"","person":_vm.$_profilePerson,"startDate":_vm.startDate,"endDate":_vm.endDate,"showAbsences":false,"showEvents":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }